import { StringField } from "./StringField";

export class PhoneField extends StringField {
  public static fieldName = "PhoneField";
  public static viewComponentName: string = "view-phone-field";

  protected static icon = "mdi-phone";
}
